import { FC, useEffect } from 'react';
import serverVars from 'server-vars';

import { colors } from 'dibs-sassy/exports/colors';

import {
    SET_STEP,
    STEP_PROMO_TOKEN_ADD_USER_TO_WHITELIST,
    STEP_NO_PROMO_TOKEN,
    DispatchType,
} from './reducer';

const { sassyColorBuyerTertiary } = colors;

const promoToken = serverVars.get('promoToken');

type Props = {
    dispatch: DispatchType;
};

/**
 * Possible flows:
 * - with `promoToken` and optional `privateClientForm`
 * - no `promoToken` and `privateClientForm=TRUE`
 * - else `404` on server
 */
const IFramedPromoPartnershipFlow: FC<Props> = ({ dispatch }) => {
    useEffect(() => {
        const page = document.getElementById('page');
        if (page) {
            page.style.backgroundColor = sassyColorBuyerTertiary;
        }

        dispatch({
            type: SET_STEP,
            step: promoToken ? STEP_PROMO_TOKEN_ADD_USER_TO_WHITELIST : STEP_NO_PROMO_TOKEN,
        });
    }, [dispatch]);

    return null;
};

export default IFramedPromoPartnershipFlow;
